const DocumentLink = require('./document-link.js');

(($) => {
    const documentLinkSelector = 'a[href*="//shared.portals.lumeris.io/"]';
    const $body = $('body');
    const $documentLinks = $(documentLinkSelector);
    const documentLinks = [];
    const observer = new MutationObserver(onBodyMutation);

    observer.observe($body.get(0), {
        childList: true,
        subtree: true
    });

    window.addEventListener('load', init);

    async function init() {
        if ($documentLinks.length === 0) {
            return false;
        }

        $documentLinks.each((linkIndex, linkElement) => {
            documentLinks.push(new DocumentLink(linkIndex, linkElement));
        });

        for (const doc of documentLinks) {
            await doc.init();
        }
    }

    function onBodyMutation(mutations) {
        if (!(mutations instanceof Object)) {
            return null;
        }
        
        mutations.forEach((mutation) => {
            const $newDocumentLinks = $(mutation.addedNodes).filter(documentLinkSelector);

            $newDocumentLinks.each((i, el) => {
                new DocumentLink(null, node);
            });
        });
    }
})(jQuery);